import { render, staticRenderFns } from "./TaskDataPoints.vue?vue&type=template&id=5f1f6e0e&scoped=true&"
import script from "./TaskDataPoints.vue?vue&type=script&lang=ts&"
export * from "./TaskDataPoints.vue?vue&type=script&lang=ts&"
import style0 from "./TaskDataPoints.vue?vue&type=style&index=0&id=5f1f6e0e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f1f6e0e",
  null
  
)

export default component.exports